/**
 * Место размещения баннеров
 */
export enum BannerPlace {
  /**
   * Перед master-header, зона глобальной нотификации
   */
  HeaderNotification = 'headerNotification',
}
